export const PLAYBACK_RATES = [0.8, 1.0, 1.2, 1.5] as const

export type PlaybackRate = typeof PLAYBACK_RATES[number]
